<template>
    <div>
        <div
            class="kgr-region kgr-region--lightGray kgr-region--rounded kgr-row kgr-row--bigMargin"
        >
            <h2
                v-t="'club.dog.memberRelation.create.title'"
                class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText"
            ></h2>
            <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--center">
                <div
                    class="kgr-postfix__fixed"
                    :class="{'error-state': error.forField('relationMember')}"
                >
                    <div class="kgr-inputGroup__label">
                        {{ $t('Mitglied') }}
                    </div>
                    <kgr-club-member-select
                        ref="memberSelect"
                        v-model="relation.member"
                        :club-id="clubId"
                    />
                </div>

                <div
                    class="kgr-postfix__fixed"
                    :class="{'error-state': error.forField('relationAssociation')}"
                >
                    <div class="kgr-inputGroup__label">
                        {{ $t('Zugehörigkeit') }}
                    </div>
                    <kgr-generic-select
                        v-model="relation.association"
                        :options="associationOptions"
                        display="label"
                        :error="error.messageForField('relationAssociation')"
                    />
                </div>

                <div class="kgr-postfix__fixed">
                    <kgr-button
                        :value="$t('add')"
                        :pending="pendingCreate"
                        :disabled="isDisabled"
                        class="dogRelationAddButton"
                        @click="addRelation()"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ClubMemberSelect from '../common/form/select/ClubMemberSelect.vue';
import Error from '../../js/model/Error.js';
import GenericSelect from '../common/form/select/GenericSelect.vue';
import KgrButton from '../common/form/button/KgrButton.vue';

export default {
    components: {
        'kgr-button': KgrButton,
        'kgr-club-member-select': ClubMemberSelect,
        'kgr-generic-select': GenericSelect,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        relations: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        },
        error: {
            type: Error,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            associationOptions: [
                {label: this.$t('club.dog.memberRelation.association.owner'), value: 'owner'},
                {label: this.$t('club.dog.memberRelation.association.handler'), value: 'handler'}
            ],
            relation: {},
            pendingCreate: false,
        }
    },
    computed: {
        isDisabled() {
            return this.relation.member === undefined || this.relation.association === undefined;
        }
    },
    created() {
    },
    methods: {
        addRelation() {
            this.$emit('addRelation', this.relation);
            this.$refs.memberSelect.resetSelected();
            this.relation = {};
        },
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  .dogRelationAddButton {
      margin-top: 18px;
  }
  .error-state {
    border-color: #F44336;
  }
</style>
